/* =====================================================================
   INDUCTION HARDWARE — HOMEPAGE INTERACTIONS
   Scroll reveal, DC-hood dB slider, evolution timeline tabs, newsletter.
   Loaded (deferred) by several homepage sections; init is idempotent.
===================================================================== */
(function () {
  if (window.__ihHomeInit) return;
  window.__ihHomeInit = true;

  function init() {
    /* ---------- Scroll reveal ---------- */
    var els = document.querySelectorAll('.ih-home .reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }

    /* ---------- DC hood dB slider ---------- */
    document.querySelectorAll('[data-db-meter]').forEach(function (meter) {
      var stops;
      try { stops = JSON.parse(meter.getAttribute('data-stops') || '[]'); } catch (e) { stops = []; }
      if (!stops.length) return;
      var slider = meter.querySelector('.db__slider');
      var num = meter.querySelector('[data-db-num]');
      var unit = meter.querySelector('[data-db-unit]');
      var desc = meter.querySelector('[data-db-desc]');
      var cmpIH = meter.querySelector('[data-db-ih]');
      var cmpOther = meter.querySelector('[data-db-other]');
      var img = document.querySelector('[data-hood-img]');
      var ihDb = stops[0].db;
      if (slider) { slider.max = String(stops.length - 1); }
      function render(i) {
        var d = stops[i]; if (!d) return;
        if (num) num.textContent = d.db;
        if (unit && d.unit) unit.textContent = d.unit;
        if (desc) desc.innerHTML = d.desc || '';
        if (cmpIH) cmpIH.textContent = ihDb + ' dB';
        if (cmpOther) cmpOther.textContent = d.db + ' dB';
        if (img) img.style.filter = 'brightness(' + (1 - i * 0.08) + ') saturate(' + (1 - i * 0.12) + ')';
      }
      if (slider) slider.addEventListener('input', function (e) { render(Number(e.target.value)); });
      render(0);
    });

    /* ---------- Evolution timeline tabs ---------- */
    document.querySelectorAll('[data-timeline]').forEach(function (tl) {
      var tabs = tl.querySelectorAll('.tl__tab');
      var imgs = tl.querySelectorAll('.tl__media img');
      var kicker = tl.querySelector('[data-tl-kicker]');
      var title = tl.querySelector('[data-tl-title]');
      var desc = tl.querySelector('[data-tl-desc]');
      function show(era, btn) {
        if (kicker) kicker.textContent = btn.getAttribute('data-kicker') || '';
        if (title) title.innerHTML = btn.getAttribute('data-title') || '';
        if (desc) desc.textContent = btn.getAttribute('data-desc') || '';
        tabs.forEach(function (b) { b.classList.toggle('active', b === btn); });
        imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-era') === era); });
      }
      tabs.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-era'), b); }); });
    });

    /* ---------- Newsletter (demo) ---------- */
    document.querySelectorAll('[data-news-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        form.style.display = 'none';
        var thanks = form.parentNode.querySelector('[data-news-thanks]');
        if (thanks) thanks.hidden = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
